export const compareCatalogRelevance = (a, b, relevanceOrder = []) => {
  const relevanceRanks = new Map(relevanceOrder.map((productId, index) => [String(productId), index]))
  const aRank = relevanceRanks.get(String(a?._id))
  const bRank = relevanceRanks.get(String(b?._id))

  if (aRank !== undefined || bRank !== undefined) {
    if (aRank === undefined) return 1
    if (bRank === undefined) return -1
    if (aRank !== bRank) return aRank - bRank
  }

  return (b?.marketing_priority || 1) - (a?.marketing_priority || 1)
}

export default compareCatalogRelevance
